import { Navigate, Route, Routes } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import Dashboard from "../pages/Dashboard";
import DieStatus from "../pages/DieManagement/DieStatus";
import Location from "../pages/DieManagement/Location";
import Customer from "../pages/SalesOrders/Customer";
import Alloy from "../pages/SalesOrders/Alloy";
import OrderStatus from "../pages/SalesOrders/OrderStatus";
import OrderPlanView from "../pages/OrderPlanView/OrderPlanView";
import DieMaster from "../pages/DieManagement/DieMaster";
import SalesOrderMaster from "../pages/SalesOrders/SalesOrderMaster";
import Foundry from "../pages/Foundry/FoundryMaster";
import Spectro from "../pages/Foundry/SpectroMaster";
import AllStocks from "../pages/RawMaterial/AllStocks";
import InProduction from "../pages/InProduction";
import QC from "../pages/QC";
import Aging from "../pages/Aging";
import ToolingSize from "../pages/DieManagement/ToolingSize";
import DieType from "../pages/DieManagement/DieType";
import Packing from "../pages/Packing";
import SupplierDie from "../pages/DieManagement/SupplierDie";
import RawMaterial from "../pages/RawMaterial/RawMaterial";
import MaterialInward from "../pages/RawMaterial/MaterialInward";
import Login from "../components/Auth/Login";
import Users from "../pages/Settings/Users";
import Cookies from "js-cookie";
import MenuMaster from "../pages/Settings/MenuMaster";
import MenuPermission from "../pages/Settings/MenuPermission";
import UnitConversion from "../pages/SalesOrders/UnitConversion";
import ToolingEntry from "../pages/ToolingEntry";
import ToolingType from "../pages/ToolingEntry/ToolingType";
import NalcoMaster from "../pages/Settings/NalcoMaster";

// const ProtectedRoute = ({ children }) => {
//   const token = Cookies.get("token");
//   return token ? children : <Navigate to="/login" replace />;
// };

const ProtectedRoute = ({ children }) => {
  const user = sessionStorage.getItem("user");
  return user ? children : <Navigate to="/login" replace />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="*" element={<Navigate to="/dashboard" replace />} />
    <Route
      path="/login"
      element={
        <>
          <PageTitle title="Login" />
          <Login />
        </>
      }
    />
    <Route
      path="/dashboard"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Dashboard" />
            <Dashboard />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/die-management/die-status"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Die Status" />
            <DieStatus />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/die-management/supplier-die"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="supplier-die" />
            <SupplierDie />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/die-management/location"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="location" />
            <Location />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/die-management/toolingSize"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="ToolingSize" />
            <ToolingSize />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/die-management/dieType"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="DieType" />
            <DieType />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/die-management/die-master"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="die-master" />
            <DieMaster />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/sales-orders/sales-customer"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="sales-customer" />
            <Customer />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/sales-orders/alloy"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="alloy" />
            <Alloy />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/sales-orders/order-status"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="order-status" />
            <OrderStatus />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/sales-orders/unit-conversion"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="unit-conversion" />
            <UnitConversion />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/sales-orders/order-master"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="order-master" />
            <SalesOrderMaster />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/order-plan-view"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Order Plan View" />
            <OrderPlanView />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/raw-material"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Raw-Material" />
            <RawMaterial />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/material-inward"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Material-Inward" />
            <MaterialInward />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/all-stock"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="All-Stocks" />
            <AllStocks />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/foundry"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Foundry" />
            <Foundry />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/spectro"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Spectro" />
            <Spectro />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/in-production"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="In-Production" />
            <InProduction />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/qc"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="QC" />
            <QC />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/aging"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Aging" />
            <Aging />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/packing"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="/Packing" />
            <Packing />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/tooling-Entry"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="/Tooling-Entry" />
            <ToolingEntry />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/tooling-type"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="/Tooling-Type" />
            <ToolingType />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/settings/users"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="/Users" />
            <Users />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/settings/menu-master"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="MenuMaster" />
            <MenuMaster />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/settings/menu-permission"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="MenuPermission" />
            <MenuPermission />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/settings/nalco-master"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Nalco-Master" />
            <NalcoMaster />
          </ProtectedRoute>
        </>
      }
    />
  </Routes>
);

export default AppRoutes;
